import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@jbnl/shared-ui";

/**
 * The Backoffice's component: a regiocontact picking a korps is doing what a beheerder does on
 * `/ploegen`. CSS rather than a matchMedia hook, which answers "desktop" on a phone's first
 * paint. The list pane does not scroll within itself; the korpsenlijst is paginated.
 */
export function ListDetail({
  list,
  detail,
  selected,
  backLabel,
  onBack,
}: {
  list: ReactNode;
  detail: ReactNode;
  selected: boolean;
  backLabel: string;
  onBack: () => void;
}) {
  return (
    <div className="grid gap-6 md:grid-cols-[19rem_1fr] lg:grid-cols-[24rem_1fr]">
      <div
        className={cn(
          "min-w-0 md:sticky md:top-20 md:self-start",
          selected && "hidden md:block",
        )}
      >
        {list}
      </div>

      <div className={cn("min-w-0", !selected && "hidden md:block")}>
        {selected && (
          <Button
            variant="outline"
            size="sm"
            className="mb-4 md:hidden"
            onClick={onBack}
          >
            <ChevronLeft />
            {backLabel}
          </Button>
        )}
        {detail}
      </div>
    </div>
  );
}
